/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { apiRequest } from "../../utils/api";
import { useNotification } from "../../context/notification";

import Select from "../Select";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  select: {
    color: "#0a859a",
    "&:before": {
      borderBottom: "2px solid #0a859a",
    },
  },
}));

function CampaignFilter({
  handleCampaignChange,
  showUserCampaignsOnly = false,
  uid, // Required if showUserCampaignsOnly is true
  ...props
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { addNotification } = useNotification();
  const [isLoading, setIsLoading] = useState(true);
  const [campaignList, setCampaignList] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState("all");

  useEffect(() => {
    getFilterCampaigns();
  }, []);
  useEffect(() => {
    handleCampaignChange(selectedCampaign);
  }, [selectedCampaign]);

  async function getFilterCampaigns() {
    setIsLoading(true);

    const apiUrl = showUserCampaignsOnly
      ? `/api/getUserCampaignList?uid=${uid}`
      : `/api/getSupportAdminAllCampaigns`;

    const response = await apiRequest.get(apiUrl);

    if (response.status === 200) {
      let data = response.data.data;
      if (data.length > 0) {
        data = data.map(item => {
          return {
            value: item.campaign_id,
            label: item.sub_functional_unit,
            groupBy: item.functional_unit,
            ...item,
          };
        });
        data = [{ value: "all", label: t("sessionList.allCampaign") }, ...data];
        setCampaignList(data);
      }
    } else {
      addNotification(
        t("error.couldNotGetCountryList") +
          ` (Status code: ${response.status})`,
        "error"
      );
    }
    setIsLoading(false);
  }

  return (
    <>
      {campaignList && (
        <Select
          list={campaignList}
          searchable={true}
          value={selectedCampaign}
          className={`${classes.select} ${styles.toolBarDropDown}`}
          variant="standard"
          groupBy={true}
          onChange={e => {
            setSelectedCampaign(e.target.value);
          }}
        />
      )}
    </>
  );
}

export default CampaignFilter;
